// extracted by mini-css-extract-plugin
export default {"play":"ooiRgE","pause":"vIz7nG"};